import React from "react";
import { Text, Image } from "react-native";
import styled from "styled-components/native";
import Dialog from "../dialog/Dialog";
import Button from "../button/Button";
import { Container } from "../layout/common";

const Photo = styled.Image`
  flex: 1;
  border-radius: 10px;
`;

/*
 * Modal image viewer component with the following props.
 *  - blob: Base64 image data.
 *  - mime: Mime type of the image.
 */
const ViewerDialog = ({ mime, blob, onClose, ...restProps }) => (
  <Dialog
    style={{
      display: "flex",
      flexDirection: "column",
      borderWidth: 1,
      borderColor: "#fff"
    }}
    {...restProps}
  >
    {/* Image to be displayed */}
    <Photo source={{uri: `data:${mime};base64,${blob}`}} resizeMode="contain" />

    {/* Ok Button that close the modal */}
    <Container flexDirection="row" justifyContent="flex-end" margins="15px 0 0 0">
      <Button
        title="Ok"
        onPress={onClose}
      />
    </Container>
  </Dialog>
);

export default ViewerDialog;
